/**
 * US QUESTIONS HOMEPAGE
 */

import { GetServerSideProps } from "next";
import { serverSideTranslations } from "../../common/utility/serverSideTranslations";
import { getSelectorsByUserAgent } from "react-device-detect";
import { convertLangToXLocale } from "../../domains/qi/services/utiltyService";
import { saveContentLangToCookie } from "../../common/services/utilityService";
import { getCachedCourses } from "../../domains/qi/services/cachedCourseService";
import { IKunduzRequest } from "../../common/interfaces";
import { initalizeMiddlewares } from "../../common/middlewares";
import HomeSUGPage from "../../domains/qi/pages/homePage/homeSUGPage";
import { getCachedHeaderItems } from "../../common/services/cachedHeaderItems";
import { getCachedHeaderBanner } from "../../common/services/cachedHeaderBanner";

export default function Index(props) {
  return <HomeSUGPage {...props} />;
}

export const getServerSideProps: GetServerSideProps = async ({
  params,
  req,
  res,
  locale,
  query,
}) => {
  await initalizeMiddlewares(req, res, "");
  const { kz_user_token } = req.cookies;
  const { isMobile } = getSelectorsByUserAgent(req.headers["user-agent"]);
  const lang = "en";
  const page = Number((query.page as string) || "1");
  const perPage = 50;
  const localeHeader = convertLangToXLocale(lang as string);

  saveContentLangToCookie(lang, { res });
  const courses = await getCachedCourses(lang);
  const headerItems = await getCachedHeaderItems(lang, "student");
  const headerBanner = await getCachedHeaderBanner(lang);

  let questions = {
    results: [],
    total: 0,
  };
  try {
    questions = await (
      req as IKunduzRequest
    ).elasticClient.getLastQuestionsByHomeSUGPage(localeHeader, page, perPage);
  } catch (error) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      courses,
      lang,
      page,
      questions: questions.results,
      total: questions.total,
      perPage,
      isMobile,
      isAuth: !!kz_user_token,
      headerItems,
      headerBanner,
      ...(await serverSideTranslations(lang, [
        "questionIndexing",
        "kunduzcom_common",
      ])),
    },
  };
};
